import React from 'react'
import TypewriterComponent from 'typewriter-effect'
import bulb from "../public/light.jpg"

import Image from 'next/image'
const Commingsoon = () => {
    return (
        <div>
            <div className="relative  h-[50rem] w-[90%] m-auto mt-[12rem] mb-[5rem] flex flex-col justify-center items-center bg-gray-300 rounded-3xl shadow-[inset_4px_5px_6px_rgba(0,0,0,0.2)] text-[#454545]     text-7xl font-bold">
                <TypewriterComponent
                    className=""
                    onInit={(typewriter) => {

                        typewriter

                            .typeString("Cloudastra")

                            .pauseFor(1000)
                            .deleteAll()
                            .typeString("Welcomes You")
                            .start()
                            .pauseFor(1000)
                            .deleteAll()
                            .typeString("Page Coming Soon ")
                            .start();
                    }}
                />
            </div>
            {/* <Image className='absolute top-1 z-0' alt='bulb' src={bulb} /> */}
        </div>
    )
}

export default Commingsoon